import React from 'react';
import styled from 'styled-components';
import Header from './header';
import Footer from './footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Main = styled.main`
  min-height: 100vh;
  padding-top: 80px; // To account for the fixed header
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Header />
      <Main>{children}</Main>
      <Footer />
    </>
  );
};

export default Layout;
